import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

export function paAlternativesSwiper() {
	document.querySelectorAll('.pa-alternatives-slider').forEach((el) => {
		new Swiper(el, {
			spaceBetween: 16,
			slidesPerView: 'auto',
			slidesOffsetAfter: 0,
			slidesOffsetBefore: 0,
			modules: [Navigation],
			navigation: {
				nextEl: el.querySelector('.swiper-button-next'),
				prevEl: el.querySelector('.swiper-button-prev'),
			},
		});
	});
}
